import {useCallback, useEffect, useRef} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {setUpdateSWStatus} from '@/actions/updateSystemAction';
import {getStatus} from '@/api/deviceApi';
import {refreshBrowser} from '@/businesses/appBusiness';
import {UpdateSWStatusType} from '@/constants/dataEnum';
import {getItem} from '@/libs/systemUpdateStorage';
import {getIsAutoRefreshUpdateSW} from '@/selectors/signalRSelector';

const INTERVAL = 3000;
const MAX_REMAINING_TIME = 1000 * 60 * 30;

const useAutoRefreshUpdateSW = () => {
  const dispatch = useDispatch();
  const isAutoRefreshUpdateSW = useSelector(getIsAutoRefreshUpdateSW);
  const intervalRef = useRef();
  const remainingRef = useRef(0);

  const clear = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = null;
    remainingRef.current = 0;
  }, []);

  const register = useCallback(() => {
    clear();

    if (getItem()) {
      intervalRef.current = setInterval(async () => {
        if (remainingRef.current >= MAX_REMAINING_TIME) {
          dispatch(setUpdateSWStatus(UpdateSWStatusType.FAILED));
          clear();
          return;
        }

        remainingRef.current += INTERVAL;

        const response = await getStatus(true);

        if (response.data) {
          refreshBrowser();
          clear();
        }
      }, INTERVAL);
    }
  }, [clear, dispatch]);

  useEffect(() => {
    if (isAutoRefreshUpdateSW) register();
    else clear();

    return () => {
      clear();
    };
  }, [clear, isAutoRefreshUpdateSW, register]);

  return null;
};
export default useAutoRefreshUpdateSW;
